import AntdSteps from 'components/AntdSteps'
import { Form } from 'components/UIComponents/FormStyles'
import moment from 'moment'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import { systemConfig } from 'utils/config.js'
import { removeDuplicatesFromArray } from 'utils/removeDuplicatesFromArray'
import {
  dateConversion,
  isReturnBoolean,
  timeCheck,
  timeSplit,
} from '../../../../utils/rolecreationHelpers'
import {
  Container,
  LastDiv,
  LeftDiv,
  RightDiv,
  StickyLeftDiv,
  StickyQualificationRightDiv,
  StickyRightDiv,
} from '../../NewJobRole/RolesForm/style'
import CompanyCard from '../CompanyCard'
import AutoJDFill from './Partials/AutoJDFill'
import EligibiltyCriteria from './Partials/EligibiltyCriteria'
import JobDetails from './Partials/JobDetails'

import { Spin } from 'antd'
import EmailTemplate from 'components/EmailTemplate'
import RoleUpdateIneligibleTemplate from 'components/EmailTemplate/RoleUpdateIneligibleTemplate'
import { formatAMPM } from 'modules/JobPreview/constant'
import {
  sendInAppNotification,
  sendNotificationBulkEmailWhatsapp,
} from 'modules/Students/actions'
import ReactDOMServer from 'react-dom/server'
import { useDispatch } from 'react-redux'
import { formatNumber } from 'utils/formatNumber'
import CloseRoleDrawer from '../../../../components/UIComponents/CloseRolePopup'
import PreviewPage from '../../../../components/UIComponents/PreviewScreen'
import ShortlistIcon from '../../../../components/icons/Shortlist'
import isValidUUID from '../../../../utils/isValidUUID'
import PreviewScreenCard from '../CompanyCard/PreviewScreenCard'
import {
  autoJDFillStepNum,
  checkValidationCopy,
  ctcOrStipendStepNum,
  eligibilityCriteriaStepNum,
  isCTCAndLocationFilled,
  isEligibilityCriteriaEqual,
  isJobDetailsFilled,
  isQualityCriteriaValid,
  jobDetailsStepNum,
  payloadDataFormatForPreviewData,
  payloadDataFormatForQualification,
  previewStepNum,
} from './Partials/EligibiltyCriteria/CommonFunctions'
import QualificationSelectionBubble from './Partials/EligibiltyCriteria/QualificationSelectionBubble'
import StipendDetails from './Partials/Stipend'
import NotificationModal from './components/NotificationModal'
const RolesForm = ({
  currentStep,
  setCurrentStep,
  handleAddNewCompany,
  getListOfCompanies,
  getMasterSearchApi,
  getRolesListData,
  setRoleFormData,
  roleFormData,
  rolesList,
  companyList,
  save,
  setSave,
  onAddNewRole,
  setLoad,
  getListOfCities,
  updateNewRole,
  id,
  setId,
  getSpecialisationList,
  specialisationList,
  setSkillSearch,
  degreeListData,
  listOfMandatorySkills,
  setListOfMandatorySkills,
  skillCount,
  listOfOptionalSkills,
  getCandidateMetrics,
  roleForm,
  key,
  setInitialLoading,
  setKey,
  getEligibilityCriteriaQualification,
  getDegreeData,
  degreeList,
  selectedType,
  setSelectedType,
  jobRolePreviewData,
  editData,
  setScoreType,
  scoreType,
  getJobRolePreview,
  stepIcon,
  checkAllCompleted,
  labelName,
  setLabelName,
  qualificationError,
  setQualificationError,
  mandatoryTypeError,
  setMandatoryTypeError,
  setShowRoleDrawer,
  showRoleDrawer,
  publishCheck,
  setLengthError,
  lengthError,
  step,
  setStepStatus,
  stepStatus,
  hasNotChanged,
  setPreviewData,
  previewData,
  confirmLoading,
  setConfirmLoading,
  draft,
  setDraft,
  setPublishCheck,
  jdFile,
  setJdFile,
  parseLoading,
  setParseLoading,
  handleNextChange,
  getJdDetails,
  setJdData,
  jobDetailsForm,
  params,
  searchCities,
  deleteRole,
  setDeleteRole,
  deleteJobRole,
  defaultRoleFormData,
  instituteCampusId,
  triggerBack,
  setTriggerBack,
  getEligibilityCriteria,
  setIsEditModal,
  initialResponse,
  isEditModal,
  criteriaTypes,
  skillSearch,
  fetchRoleData,
  setButtonLoading,
  handleButtonChanges,
  setCandidateMetrics,
  candidateMetrics,
  revertInEligibleStudent,
  setOpen,
  getCities,
  sendNotificationBulkEmail,
  getInEligibleCandidates,
  isEdited,
  setIsEdited,
  listOfSkills,
  setListOfSkills,
  selectedSkills,
  setSelectedSkills,
  mandatorySkillsIds,
  setMandatorySkillsIds,
  skillsManuallyModified,
  setSkillsManuallyModified,
}) => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  const dispatch = useDispatch()
  const dateFormat = 'DD/MM/YYYY'
  const institute = useSelector(state => state.auth.instituteDetails)
  const userData = useSelector(state => state.auth.userData)
  const userRole = useSelector(state => state.auth.userRoleList)
  const [progress, setProgress] = useState(0)
  const object = useRef()
  const [marksValue, setMarksValue] = useState({
    tenthValue: roleFormData?.scores?.tenth,
    twelfthValue: roleFormData?.scores?.twelfth,
    ugMarksValue: roleFormData?.scores?.UG,
    pgMarksValue: roleFormData?.scores?.PG,
  })
  const [scoreError, setScoreError] = useState('')
  const [closeDrawerDescription, setCloseDrawerDescription] = useState(
    <>Are you sure you want to float this role?</>
  )
  const [revertStudentDrawer, setRevertStudentDrawer] = useState(false)
  const [isDateOnlyEdited, setIsDateOnlyEdited] = useState(false)

  const ScrollRef = () => {
    object.current.scrollIntoView({ top: 0, behavior: 'smooth' })
  }
  const [criteriaData, setCriteriaData] = useState([])
  const [selectedData, setSelectedData] = useState([])
  const [gigsErr, setGigsErr] = useState('')
  const [experienceErr, setExperienceErr] = useState('')
  const [selectedSpecialisations, setSelectedSpecialisations] = useState([])
  const [functionData, setFunctionData] = useState([])
  const [companyNameSearch, setCompanyNameSearch] = useState('')
  const [roleNameSearch, setRoleNameSearch] = useState('')
  const [functionNameSearch, setFunctionNameSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [forRevert, setForRevert] = useState(false)
  const [fromTabChange, setFromTabChange] = useState(false)
  const [selectedTypeJobRoles, setSelectedTypeJobRoles] = useState(null)

  const stepData = [
    {
      key: 1,
      activeKey: 0,
      title: 'Auto fill JD',
      completed: false,
    },
    {
      key: 2,
      activeKey: 1,
      title: 'Job Details',
      completed: false,
    },
    {
      key: 3,
      activeKey: 2,
      title: labelName,
      completed: false,
    },
    {
      key: 4,
      activeKey: 3,
      title: 'Eligibility Criteria',
      completed: false,
    },
    {
      key: 5,
      activeKey: 4,
      title: 'Preview',
      completed: false,
    },
  ]
const prevJobCategoryRef = useRef(roleFormData?.jobDetails?.jobCategory);

useEffect(() => {
  const prev = prevJobCategoryRef.current;
  const current = roleFormData?.jobDetails?.jobCategory;

  if (prev && current && prev !== current) {
    setRoleFormData(prevData => ({
      ...prevData,
      ctc: {
        ...prevData.ctc,
        isRange: false,
        min: null,
        max: null,
        variableAmount: null,
      },
    }));

    roleForm?.setFieldsValue({
      ctc: {
        isRange: false,
        min: null,
        max: null,
        variableAmount: null,
      },
    });
  }

  prevJobCategoryRef.current = current;
}, [roleFormData?.jobDetails?.jobCategory]);

  useEffect(() => {
    eligibleCandidatesMetrics(roleFormData)
  }, [criteriaData])

  const eligibleCandidatesMetrics = useCallback(async data => {
    const yearOfExperience =
      data?.jobDetails?.jobTypeLevels === 'ENTRY'
        ? [0]
        : calculateYearsOfExperience(data?.jobDetails)
    let payloadData = []

    if (data?.qualityCriteria?.length > 0) {
      let qualityCriteria =
        data?.qualityCriteria?.map(item => item.selected) || []

      payloadData = payloadDataFormatForQualification(qualityCriteria)
    }

    const mappedCities =
      (data?.jobLocation?.cities || []).map(item => item?.payload ?? item)

    let payload = {
      roleId: params.roleId,
      eligibilityCriteria: payloadData,
      jobTypeLevels: data?.jobDetails?.jobTypeLevels
        ? [data?.jobDetails?.jobTypeLevels]
        : [],
      yearOfExperience: yearOfExperience,
      jobLocation: {
        ...(data.jobLocation || {}),
        cities: mappedCities,

        isAnyWhere: data?.jobLocation?.isAnyWhere,
      },
      yearOfPassing: data?.yearOfPassing || [],
      allowArrears: data?.isArrearsAllowed || false,
      isHistoryArrears: data?.isHistoryArrears || false,
      minimumScore: {
        minimumTenthMark: data?.scores?.tenth || 0,
        minimumTwelfthMark: data?.scores?.twelfth || 0,
      },
      arrearCount: data?.arrearCount?.count || 0,
      historyArrearCount: data?.historyArrearCount?.count || 0,
      priorityDegree: data?.priorityDegree || '',
    }

    if (data?.qualityCriteria[0]?.totalTypes?.length > 0) {
      data.qualityCriteria[0].totalTypes.forEach(item => {
        if (item === 'DIPLOMA') {
          payload.minimumScore.minimumDiplomaMark = data.scores['UGDiploma']
        } else if (item === 'UG') {
          payload.minimumScore.minimumUgMark = data.scores['UG']
        } else if (item === 'PG') {
          payload.minimumScore.minimumPgMark = data.scores['PG']
        }
      })
    }
    const mandatorySkillIds = Array.isArray(data?.jobRoleSkills)
      ? data.jobRoleSkills
          .filter(s => s?.isMandatory)
          .map(s => s?.skillId || s?.id || s?.value)
          .filter(Boolean)
      : []

    if (mandatorySkillIds.length > 0) {
      payload.mandatorySkills = {
        mandatory: mandatorySkillIds,
        mandatorySkillName: data.jobRoleSkills?.filter(s => s?.isMandatory)?.map(s => s?.name),
        mandatoryCount: data.jobRoleSkills?.filter(s => s?.isMandatory)?.length
      }
    }
    const metrics = await getCandidateMetrics(payload)
    setCandidateMetrics(metrics)
  }, [])
  const functionApi = async (search = '') => {
    let payLoad = systemConfig.function
    payLoad.q = search
    const data = await getMasterSearchApi('function', payLoad)
    setFunctionData(data)
  }
  const roleApi = async (search = '') => {
    getRolesListData(
      setLoading,
      `pageLimit=50&pageNo=1&search=${search.trim()}`
    )
  }
  const companiesApi = async (search = '') => {
    getListOfCompanies(search)
  }
  const calculateYearsOfExperience = jobDetails => {
    let years =
      jobDetails?.firstYear +
      '.' +
      jobDetails?.firstMonth +
      ',' +
      jobDetails?.secondYear +
      '.' +
      jobDetails?.secondMonth
    let result = years?.split(',').map(parseFloat)
    if (result.every(num => num === 0)) {
      return [0]
    }
    return result
  }

  const calculateGigsDuration = jobDetails => {
    let years =
      jobDetails?.durationFirstYear +
      '.' +
      jobDetails?.durationFirstMonth +
      ',' +
      jobDetails?.durationSecondYear +
      '.' +
      jobDetails?.durationSecondMonth
    return years?.split(',')?.map(parseFloat)
  }

  const checkValidation = (
    fieldName,
    fieldNameValue,
    firstYear,
    firstMonth,
    secondYear,
    secondMonth,
    errSet,
    statusField,
    errId,
    fillMessage,
    invalidMessage
  ) => {
    if (
      roleFormData?.jobDetails[fieldName] &&
      roleFormData?.jobDetails[fieldName] == fieldNameValue &&
      currentStep === jobDetailsStepNum
    ) {
      const firstTotalMonths =
        Number(roleFormData?.jobDetails?.[firstYear]) * 12 +
        Number(roleFormData?.jobDetails?.[firstMonth])
      const secondTotalMonths =
        Number(roleFormData?.jobDetails?.[secondYear]) * 12 +
        Number(roleFormData?.jobDetails?.[secondMonth])
      const idError = document.getElementById(errId)
      if (secondTotalMonths) {
        if (firstTotalMonths === secondTotalMonths && firstTotalMonths !== 0) {
    errSet(`${invalidMessage}`)
    statusField = true
    idError.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })
    return statusField
  }
        if (firstTotalMonths > secondTotalMonths) {
          errSet(`${invalidMessage}`)
          statusField = true
          idError.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        } else {
          statusField = false
          errSet('')
        }
      }
      if (secondTotalMonths === 0 && firstTotalMonths === 0) {
        errSet(`${fillMessage}`)
        statusField = true
        idError.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      } else if (secondTotalMonths === 0) {
        errSet(`${invalidMessage}`)
        statusField = true
        idError.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
    } else {
      statusField = false
      errSet('')
    }
    return statusField
  }
  const [errorStatus, setErrorStatus] = useState('')
  const tabValidationChecking = () => {
    if (roleFormData) {
      let gigsStatuses = false
      let jobLevelStatuses = false

      gigsStatuses = checkValidationCopy(
        roleFormData,
        currentStep,
        'jobCategory',
        'GIGS',
        'durationFirstYear',
        'durationFirstMonth',
        'durationSecondYear',
        'durationSecondMonth',
        setErrorStatus,
        gigsStatuses,
        'gigsError',
        'Please enter a duration',
        'Please enter a valid duration'
      )

      jobLevelStatuses = checkValidationCopy(
        roleFormData,
        currentStep,
        'jobTypeLevels',
        roleFormData?.jobDetails?.jobTypeLevels,
        'firstYear',
        'firstMonth',
        'secondYear',
        'secondMonth',
        setErrorStatus,
        jobLevelStatuses,
        'jobLevel_status_Id',
        'Please enter the experience',
        'Please enter the valid experience'
      )

      const jd = currentStep > 0 || jdFile?.length

      const job = isJobDetailsFilled(
        roleFormData?.jobDetails,
        gigsStatuses,
        jobLevelStatuses
      )

      const ctc = isCTCAndLocationFilled(
        roleFormData?.ctc,
        roleFormData.jobLocation,
        roleFormData?.jobDetails?.jobCategory,
        roleFormData?.jobDetails?.workStyle
      )
      const qualification = isQualityCriteriaValid(
        roleFormData?.qualityCriteria,
        roleFormData?.yearOfPassing,
        roleFormData?.mandatorySkills
      )

      return {
        jd: jd,
        job: job,
        ctc: ctc,
        qualification: qualification,
        jd: jd,
      }
    }
  }
  useEffect(() => {
    roleForm.setFieldsValue(roleFormData)

    if (roleFormData?.status != 0) {
      setCloseDrawerDescription(
        <>Are you sure you want to republish the role?</>
      )
    }
  }, [])

  const handleConfirmPublish = async () => {
    if (
      candidateMetrics?.inEligibleList?.length &&
      roleFormData?.status == 1 &&
      !roleFormData?.republishedDate
    ) {
      setRevertStudentDrawer(true)
      return
    }

    handleButtonChanges()
    await onSubmitFormData()
    const endDateStr = dateConversion({
      date: roleFormData?.jobDetails?.endDate,
      convertTo: 'YYYY-MM-DD',
    })

    const endTimeStr = timeCheck(roleFormData?.jobDetails?.endTime) || '00:00'

    if (endDateStr) {
      const combinedDateTimeStr = `${endDateStr}T${endTimeStr}`
      const combinedDateTime = new Date(combinedDateTimeStr)
      const now = new Date()

      if (!isNaN(combinedDateTime?.getTime()) && combinedDateTime > now) {
        notificationTrigger(roleFormData?.status == 1)
      }
    }
  }

  let count = 0

  const handleRevertPop = async fromRevert => {
    count += 1

    if (count == 1) {
      handleButtonChanges()
      await onSubmitFormData(fromRevert, 'revert')
      notificationTrigger(true)

      if (fromRevert) {
        const emailPayloadIneligible = candidateMetrics?.studentDetails?.map(
          student => {
            const emailTemplate = ReactDOMServer.renderToString(
              <RoleUpdateIneligibleTemplate
                studentName={student.full_name}
                roleName={previewData?.tittle}
                companyName={previewData?.company?.companyName}
                userName={userData?.first_name + ' ' + userData?.last_name}
                userRole={getUserRoleName()}
              />
            )

            return {
              to: student.primary_email,
              subject: `Update Regarding Your Application - ${previewData?.tittle}`,
              htmlBody: emailTemplate,
            }
          }
        )

        // Students without a usable mobile number are dropped first — reading
        // .replace() off a missing number aborted the entire batch.
        const ineligibleWhatsappStudents =
          candidateMetrics?.studentDetails?.filter(
            student =>
              String(student?.contact_number ?? '').replace(/\D/g, '').length >=
              10
          )

        // Create WhatsApp payload for ineligible candidates
        const whatsappPayloadIneligible = ineligibleWhatsappStudents?.map(
          student => {
            return {
              to: String(student.contact_number).replace(/\D/g, ''),
              templateName: 'tpo_role_update_ineligible',
              type: 'template',
              components: [
                {
                  type: 'BODY',
                  parameters: [
                    { type: 'TEXT', text: student.full_name }, // {{1}} - Student name
                    { type: 'TEXT', text: previewData?.tittle }, // {{2}} - Role name
                    { type: 'TEXT', text: previewData?.company?.companyName }, // {{3}} - Company name
                  ],
                },
              ],
            }
          }
        )

        // Send email notifications for ineligible students

        if (emailPayloadIneligible) {
          await sendNotificationBulkEmail(emailPayloadIneligible, true)
        }

        if (whatsappPayloadIneligible) {
          await dispatch(
            sendNotificationBulkEmailWhatsapp(whatsappPayloadIneligible)
          )
        }
      }
      setOpen(true)
    }
  }

  const notificationTrigger = async isUpdated => {
    const result = await getInEligibleCandidates(previewData?.id)
    const companyName = previewData?.company?.companyName ||roleFormData?.companyDetails?.companyName || roleFormData?.jobDetails?.companyName || "Company";
    // Extract the list of candidates who will receive notifications
    const candidates = result?.roleReceivingCandidates || []

    const getCompensationKey = () => {
      return previewData?.jobCategory === 'PLACEMENT' ||
        previewData?.jobCategory === 'GIGS'
        ? 'CTC'
        : 'Stipend'
    }

    const getCompensationValue = () => {
      // Handle no stipend case
      if (
        !previewData?.stipend &&
        previewData?.jobCategory !== 'PLACEMENT' &&
        previewData?.jobCategory !== 'GIGS'
      ) {
        return 'No Stipend';
      }

      // If minCompensation is not set or is 0, return empty string
      if (!previewData?.hasOwnProperty('minCompensation') || 
          previewData?.minCompensation === null || 
          previewData?.minCompensation === undefined || 
          previewData?.minCompensation === '' || 
          Number(previewData?.minCompensation) === 0) {
        return '';
      }

      const minComp = Number(previewData.minCompensation);
      
      // Format the amount with Indian Rupee symbol and thousand separators
      const formattedMin = formatNumber(minComp);
      
      console.log('🔍 RolesForm CTC Debug:', {
        minCompensation: previewData?.minCompensation,
        maxCompensation: previewData?.maxCompensation,
        minType: typeof previewData?.minCompensation,
        maxType: typeof previewData?.maxCompensation,
        location: 'RolesForm/index.js'
      });
      
      // Check if maxCompensation exists and is valid to show range
      if (
  previewData?.maxCompensation &&
  previewData.maxCompensation !== null &&
  previewData.maxCompensation !== '' &&
  Number(previewData.maxCompensation) > 0 &&
  Number(previewData.maxCompensation) !== Number(previewData.minCompensation)
) {
  const maxComp = Number(previewData.maxCompensation);
  const formattedMax = formatNumber(maxComp);
  return `Annually - ₹ ${formattedMin} - ₹ ${formattedMax}`;
}
      
      // Single value - no range
      return `Annually - ₹ ${formattedMin}`;
    };

    const getTableData = () => {
      const data = {}

      // Company Name
      if (previewData?.company?.companyName) {
        data['Company Name'] = previewData.company.companyName
      }

      // Company Website
      if (previewData?.company?.website) {
        data['Company Website'] = previewData.company.website
      }

      // About Company
      if (previewData?.company?.description) {
        data['About the company'] = previewData.company.description.replace(
          /<[^>]*>/g,
          ''
        )
      }

      // Job Role
      if (previewData?.tittle) {
        data['Job role'] = previewData.tittle
      }

      // Job Type
      if (previewData?.jobCategory) {
        data['Job type'] =
          previewData.jobCategory.charAt(0).toUpperCase() +
          previewData.jobCategory.slice(1).toLowerCase()
      }

      // Experience
      const splitDate = () => {
        let date = {
          minYear: '0',
          maxYear: '0',
          minMonth: '0',
          maxMonth: '0',
        }
        if (previewData?.yearOfExperience?.length) {
          let min = String(previewData?.yearOfExperience?.[0])?.split('.')
          let max = String(previewData?.yearOfExperience?.[1])?.split('.')
          if (min?.length) {
            date.minYear = min?.[0] ?? 0
            date.minMonth = min?.[1] ?? 0
          }
          if (max?.length) {
            date.maxYear = max?.[0] ?? 0
            date.maxMonth = max?.[1] ?? 0
          }
        }
        return date
      }

      if (
        previewData?.yearOfExperience?.[0] ||
        previewData?.yearOfExperience?.[0] === 0
      ) {
        if (
          previewData?.jobTypeLevels?.[0] == 'ENTRY' ||
          previewData?.jobTypeLevels?.[0] == 'INTERN'
        ) {
          data['Experience'] = 'Fresher'
        } else {
          const date = splitDate()
          let experienceText = ''

          // Format min experience
          experienceText += Number(date.minYear)
          if (Number(date.minYear) <= 1) {
            experienceText += ' year'
          } else {
            experienceText += ' years'
          }

          // Add months for min experience if not zero
          if (Number(date.minMonth) > 0) {
            experienceText += ' ' + date.minMonth + ' months'
          }

          // Add range if max experience exists
          if (previewData?.yearOfExperience?.[1]) {
            experienceText += ' - ' + Number(date.maxYear)

            if (Number(date.maxYear) <= 1) {
              experienceText += ' year'
            } else {
              experienceText += ' years'
            }

            // Add months for max experience if not zero
            if (Number(date.maxMonth) > 0) {
              experienceText += ' ' + date.maxMonth + ' months'
            }
          }

          data['Experience'] = experienceText
        }
      }

      // Compensation
      const compensationValue = getCompensationValue()
      if (compensationValue !== 'Not specified') {
        data[getCompensationKey()] = compensationValue
      }

      // Job Location
      if (previewData?.cities?.length > 0 || previewData?.isAnyWhere) {
        data['Job location'] =
          previewData?.cities?.length > 0
            ? previewData.cities
                .map(city => city.name || city?.state_name)
                .join(', ')
            : previewData.isAnyWhere
            ? 'Anywhere'
            : ''
      }

      // Eligible Qualification
      if (previewData?.eligibilityCriteria?.length > 0) {
        const qualificationParts = []

        previewData.eligibilityCriteria.forEach((criteria, criteriaIndex) => {
          if (!criteria.selected) return

          const qualTypes = []
          Object.entries(criteria.selected || {})
            .map(([qualType, degrees]) => {
              if (!degrees || !degrees.length) return

              // Check if any degree has isAllDegree set to true
              const hasAllDegree = degrees.some(degree => degree.isAllDegree)

              if (hasAllDegree) {
                // If we have an "Any <qualification>" case, just use that and skip individual degrees
                qualTypes.push(`Any ${qualType}`)
                return // Skip processing individual degrees for this qualification type
              }

              const degreeList = []
              degrees.forEach(degree => {
                // Handle degrees with no streams
                if (!degree.streams || degree.streams.length === 0) {
                  degreeList.push(degree.shortForm)
                  return
                }

                // Handle degrees with streams and specializations
                degree.streams.forEach(stream => {
                  if (
                    stream.specialisations &&
                    stream.specialisations.length > 0
                  ) {
                    // Add each specialization
                    stream.specialisations.forEach(spec => {
                      degreeList.push(
                        `${degree.shortForm} - ${stream.name} - ${spec.name}`
                      )
                    })
                  } else {
                    // Just stream without specialization
                    degreeList.push(`${degree.shortForm} - ${stream.name}`)
                  }
                })
              })

              if (degreeList.length) {
                qualTypes.push(degreeList.join(' Or '))
              }
            })

          if (qualTypes.length) {
            qualificationParts.push(qualTypes.join(' Or '))
          }
        })

        if (qualificationParts.length) {
          data['Eligible Qualification'] = qualificationParts.join('(And)')
        }
      }

      // Year of Passing
      if (previewData?.yearOfPassing?.length > 0) {
        data['Year of Passing'] = previewData.yearOfPassing.join(', ')
      }

      // Eligible Score
      if (
        previewData?.tenthScore !== '0' ||
        previewData?.twelfthScore !== '0' ||
        previewData?.UGScore !== '0' ||
        previewData?.PGScore !== '0' ||
        previewData?.UGDiplomaScore !== null
      ) {
        const avgScore =
          previewData?.avgScore >= 30
            ? previewData?.avgScore
            : previewData?.PGScore >= 30
            ? previewData?.PGScore
            : previewData?.PGDiplomaScore !== null &&
              previewData?.PGDiplomaScore >= 30
            ? previewData?.PGDiplomaScore
            : previewData?.UGScore >= 30
            ? previewData?.UGScore
            : previewData?.UGDiplomaScore !== null &&
              previewData?.UGDiplomaScore >= 30
            ? previewData?.UGDiplomaScore
            : previewData?.twelfthScore >= 30
            ? previewData?.twelfthScore
            : previewData?.tenthScore >= 30
            ? previewData?.tenthScore
            : ''

        const scores = [
          previewData?.tenthScore && previewData?.tenthScore !== '0'
            ? `10th - ${previewData?.tenthScore}%`
            : null,
          previewData?.twelfthScore && previewData?.twelfthScore !== '0'
            ? `12th - ${previewData?.twelfthScore}%`
            : null,
          previewData?.UGScore && previewData?.UGScore !== '0'
            ? `UG - ${previewData?.UGScore}%`
            : null,
          previewData?.PGScore && previewData?.PGScore !== '0'
            ? `PG - ${previewData?.PGScore}%`
            : null,
          previewData?.UGDiplomaScore && previewData?.UGDiplomaScore !== '0'
            ? `Diploma - ${previewData?.UGDiplomaScore}%`
            : null,
        ].filter(Boolean)

        if (scores.length > 0) {
          data['Eligible score'] = `${scores.join(', ')}`
        }
      }

      //Skills Required

      // Handle Skill Set 1 (primary skills)
      const primarySkillData =
        previewData?.mandatorySkillNames?.primarySkillNames
      const mandatorySkillData =
        previewData?.mandatorySkillNames?.mandatorySkillNames

      // Check if we have both skill sets
      if (
        primarySkillData?.skillNames?.length > 0 &&
        mandatorySkillData?.length > 0
      ) {
        // Both skill sets provided - Scenario 3
        const primaryType = primarySkillData.type
        const primarySeparator =
          primaryType === 'OR' ? ' Or ' : primaryType === 'AND' ? ' And ' : ', '
        const primaryNames = primarySkillData.skillNames.map(
          skill => skill.name
        )
        data['Skills Required (Set 1)'] = primaryNames.join(primarySeparator)

        // For Set 2 (mandatory skills)
        const mandatoryNames = mandatorySkillData.map(skill => skill.name)
        const mandatoryCount =
          previewData?.mandatorySkillNames?.mandatoryCount || 1
        data['Skills Required (Set 2)'] = `${mandatoryNames.join(
          ', '
        )} (Any ${mandatoryCount} skill from this set is mandatory)`
      }
      // Only Skill Set 1 provided - Scenario 1
      else if (primarySkillData?.skillNames?.length > 0) {
        const primaryType = primarySkillData.type
        const primarySeparator =
          primaryType === 'OR' ? ' Or ' : primaryType === 'AND' ? ' And ' : ', '
        const primaryNames = primarySkillData.skillNames.map(
          skill => skill.name
        )
        data['Skills Required'] = primaryNames.join(primarySeparator)
      }
      // Only Skill Set 2 provided - Scenario 2
      else if (mandatorySkillData?.length > 0) {
        const mandatoryNames = mandatorySkillData.map(skill => skill.name)
        const mandatoryCount =
          previewData?.mandatorySkillNames?.mandatoryCount || 1
        data['Skills Required'] = `${mandatoryNames.join(
          ', '
        )} (Any ${mandatoryCount} skill from this set is mandatory)`
      }
      // Application Dates
      if (previewData?.startDate) {
        data['Application opens from'] = moment(previewData.startDate).format(
          'DD-MM-YYYY'
        )
      }

      if (previewData?.endDate) {
        const end = moment.utc(previewData.endDate);
        data['Application closes at'] = `${end.format("DD-MM-YYYY")} ${end.format("hh:mm A")}`;
      }

      return data
    }

    const tableData = getTableData()

    if (candidates.length > 0) {
      // Prepare for email notifications
      const emailPayloads = candidates.map(candidate => {
        const emailData = {
          companyName,
          jobTitle: previewData?.tittle,
          tableData,
          roleId: previewData?.id,
          corpId: previewData?.company?.id,
          type: isUpdated ? 'update' : 'create',
          signatureName: userData?.first_name + ' ' + userData?.last_name,
          signatureRole: getUserRoleName(),
          signatureInstitute: institute?.campusName || 'Institute',
          signatureContact: userData?.phone_number || institute?.contactNumber,
        }

        const emailTemplate = ReactDOMServer.renderToString(
          <EmailTemplate data={emailData} />
        )

        return {
          to: candidate.primary_email,
          subject: `${isUpdated ? 'Update' : 'New Job Role'}: ${emailData.companyName} - ${previewData?.tittle}`,
          htmlBody: emailTemplate,
        }
      })

      // Send email notifications in batch
      if (emailPayloads.length > 0) {
        await sendNotificationBulkEmail(emailPayloads, true)
      }

      // Prepare for in-app notifications
      const studentIds = candidates.map(candidate => candidate.id)

      const inAppObj = {
        notification: {
          students: [
            {
              ids: studentIds,
              userIds: [],
              roles: ['Student'],
              issuer: 'institute',
              createFor: 'student',
              inApp: true,
              body: isUpdated
                ? `Job role update: ${previewData?.tittle} at ${companyName}`
                : `New job role: ${previewData?.tittle} at ${companyName}`,
              tag: 'Role',
              actions: [
                {
                  name: 'View',
                  deep_link: `roles/viewrole/${previewData?.company?.id}/${previewData?.id}`,
                  route: `roles/viewrole/${previewData?.company?.id}/${previewData?.id}`,
                  parameters: {},
                },
              ],
            },
          ],
        },
      }

      // Send in-app notification
      await dispatch(sendInAppNotification(inAppObj))

      // Prepare for WhatsApp notifications
      const compensationValue = getCompensationValue()
      const qualifications = previewData?.eligibilityCriteria
        .map(criteria =>
          Object.entries(criteria.selected || {})
            .map(([degreeType, degrees]) =>
              degrees.map(degree => degree.shortForm).join(' And ')
            )
            .filter(Boolean)
            .join(', ')
        )
        .filter(Boolean)
        .join(', ')
const end = moment.utc(previewData.endDate);
const applicationCloseAt = `${end.format('DD-MM-YYYY')} ${end.format('hh:mm A')}`;

      // A candidate with a missing or partial mobile number previously threw
      // inside this map and aborted the whole WhatsApp batch, so nobody was
      // notified. Drop those candidates so the rest still receive the message.
      const whatsappCandidates = candidates.filter(
        candidate =>
          String(candidate?.contact_number ?? '').replace(/\D/g, '').length >= 10
      )

      const whatsappPayloads = whatsappCandidates.map(candidate => {
        // Format phone number - remove any non-digit characters except the last 10 digits
        const phone = String(candidate.contact_number).replace(/\D/g, '')
        const phoneNumber = phone.slice(-10) // Get last 10 digits

        return {
          to: phoneNumber,
          templateName: isUpdated
            ? 'tpo_application_updated'
            : 'tpo_application_create',
          type: 'template',
          components: [
            {
              type: 'BODY',
              index: 0,
              sub_type: 'CATALOG',
              parameters: [
                { type: 'TEXT', text: candidate.full_name }, // {{1}} full_name
                { type: 'TEXT', text: previewData?.tittle }, // {{2}}
                { type: 'TEXT', text: previewData?.company?.companyName }, // {{3}}
                {
                  type: 'TEXT',
                  text:
                    previewData.jobCategory.charAt(0).toUpperCase() +
                    previewData.jobCategory.slice(1).toLowerCase(),
                }, // {{4}}
                {
                  type: 'TEXT',
                  text:
                    previewData?.jobCategory === 'PLACEMENT' ||
                    previewData?.jobCategory === 'GIGS'
                      ? 'CTC'
                      : 'Stipend',
                }, // {{5}}
                { type: 'TEXT', text: compensationValue }, // {{6}}
                { type: 'TEXT', text: tableData?.['Experience'] }, // {{7}}
                { type: 'TEXT', text: tableData?.['Eligible Qualification'] }, // {{8}}
                {
                  type: 'TEXT',
                  text: applicationCloseAt,
                }, // {{9}}
                { type: 'TEXT', text: `${process.env.AUTH_URL}` }, // {{10}}
              ],
            },
          ],
        }
      })

      // Send WhatsApp notifications in batch
      if (whatsappPayloads?.length > 0) {
        await dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
      }
    }
  }
  const updateEditedFlags = () => {
    const previewEligibilityCriteria = previewData?.eligibilityCriteria
    const initialResponseEligibilityCriteria =
      initialResponse?.eligibilityCriteria

    let currentlyEdited = false

    const isOtherEdited =
      JSON.stringify({ ...previewData, eligibilityCriteria: undefined }) !==
      JSON.stringify({ ...initialResponse, eligibilityCriteria: undefined })
    const result = isEligibilityCriteriaEqual(
      previewEligibilityCriteria,
      initialResponseEligibilityCriteria
    )

    if (isOtherEdited) {
      currentlyEdited = true
    } else {
      if (!result) {
        currentlyEdited = true
      }
    }
    
    // Check if skills have changed (previewData doesn't track skill changes directly)
    if (!currentlyEdited) {
      const currentSkillIds = selectedSkills
        ?.map(s => s?.skillId || s?.id)
        ?.filter(Boolean)
        ?.sort()
      const initialSkillIds = initialResponse?.jobRoleSkills
        ?.map(s => s?.skillId || s?.id)
        ?.filter(Boolean)
        ?.sort()
      if (JSON.stringify(currentSkillIds) !== JSON.stringify(initialSkillIds)) {
        currentlyEdited = true
      }
    }

    // Check if document upload has changed (previewData doesn't track doc changes directly)
    if (!currentlyEdited) {
      const currentDocs = roleFormData?.jobDetails?.jobRoleDocs
        ?.filter(item => item?.name && item?.url)
        ?.map(item => item.url)
        ?.sort()
      const initialDocs = initialResponse?.jobRoleDocs
        ?.filter(item => item?.fileName && item?.fileUrl)
        ?.map(item => item.fileUrl)
        ?.sort()
      if (JSON.stringify(currentDocs || []) !== JSON.stringify(initialDocs || [])) {
        currentlyEdited = true
      }
    }

    setIsEdited(currentlyEdited)
    const isEndDateEdited = previewData?.endDate !== initialResponse?.endDate
    const isOtherFieldsEdited =
      JSON.stringify({
        ...previewData,
        endDate: undefined,
        eligibilityCriteria: undefined,
      }) !==
      JSON.stringify({
        ...initialResponse,
        endDate: undefined,
        eligibilityCriteria: undefined,
      })

    const onlyEndDateEdited = isEndDateEdited && !isOtherFieldsEdited

    setIsDateOnlyEdited(onlyEndDateEdited)
  }

  const onSubmitFormData = async (data, values, action, stepToGo) => {
    try {
      let completedProcess = true
      let roleDeleted = false
      if (
        currentStep == autoJDFillStepNum &&
        jdFile?.length &&
        deleteRole &&
        progress == 0
      ) {
        setTriggerBack(false)
        let completedProcess = true
        const interval = setInterval(() => {
          setProgress(prevProgress => {
            const nextProgress = prevProgress + 10
            if (nextProgress >= 100) {
              clearInterval(interval)
              return 100
            }
            return nextProgress
          })
        }, 2000)

        let isUpdated = await getJdDetails(instituteCampusId, jdFile[0]?.url)
        if (isUpdated) {
          if (params?.roleId || id) {
            const result = await deleteJobRole(params?.roleId || id)
            if (result?.message != 'Role deleted successfully') {
              completedProcess = false
              setTimeout(() => {
                localStorage.removeItem('jdDetails')
                localStorage.removeItem('jdFile')
                setParseLoading(false)
                setCurrentStep(autoJDFillStepNum)
                setProgress(0)
                setSave(false)
              }, 2000)
            } else {
              roleDeleted = true
            }
          }
          if (completedProcess) {
            localStorage.removeItem('jdDetails')
            localStorage.removeItem('jdFile')
            localStorage.setItem('jdDetails', JSON.stringify(isUpdated?.data))
            localStorage.setItem('jdFile', JSON.stringify(jdFile))
            roleFormData.jdDetails = isUpdated?.data || {}
            
            console.log('=== JD PARSING SUCCESS ===')
            console.log('JD Data received:', isUpdated?.data)
            console.log('Skills in JD data:', isUpdated?.data?.skills)
            console.log('Stored in localStorage:', localStorage.getItem('jdDetails'))
            console.log('==========================')
            
            setJdData(isUpdated)
            setProgress(100)
            setTimeout(() => {
              setCurrentStep(currentStep + 1)
              setProgress(0)
              setLoading(false)
              setConfirmLoading(false)
              setParseLoading(false)
            }, 2000)
            params.roleId = null
            setId('')
            await setRoleFormData(defaultRoleFormData)
            roleForm.setFieldsValue(defaultRoleFormData)
            // Map workStyle before setting to roleFormData
            const mapWorkStyle = (workStyleValue) => {
              if (!workStyleValue) return 'ONSITE';
              
              const normalizedValue = workStyleValue.toLowerCase().trim();
              
              // First check for exact match with allowed values (case insensitive)
              const upperValue = workStyleValue.toUpperCase().trim();
              if (['REMOTE', 'HYBRID', 'ONSITE'].includes(upperValue)) {
                return upperValue;
              }
              
              // Remote work patterns
              if (normalizedValue.includes('remote') || 
                  normalizedValue.includes('work from home') || 
                  normalizedValue.includes('wfh') || 
                  normalizedValue.includes('telecommute') ||
                  normalizedValue.includes('home-based') ||
                  normalizedValue.includes('distributed')) {
                return 'REMOTE';
              }
              
              // Hybrid work patterns
              if (normalizedValue.includes('hybrid') || 
                  normalizedValue.includes('flexible') || 
                  normalizedValue.includes('mixed') ||
                  normalizedValue.includes('part remote') ||
                  normalizedValue.includes('partially remote')) {
                return 'HYBRID';
              }
              
              // Onsite work patterns
              if (normalizedValue.includes('onsite') || 
                  normalizedValue.includes('on-site') || 
                  normalizedValue.includes('office') || 
                  normalizedValue.includes('in-person') ||
                  normalizedValue.includes('on premise') ||
                  normalizedValue.includes('on-premise')) {
                return 'ONSITE';
              }
              
              // Default fallback
              return 'ONSITE';
            };

            const mappedJdDetails = {
              ...roleFormData.jdDetails,
              workStyle: roleFormData.jdDetails.workStyle ? mapWorkStyle(roleFormData.jdDetails.workStyle) : 'ONSITE'
            };

            console.log('Original JD workStyle:', roleFormData.jdDetails.workStyle);
            console.log('Mapped JD workStyle:', mappedJdDetails.workStyle);

            await setRoleFormData(prev => ({
              ...prev,
              jobDetails: {
                ...mappedJdDetails,
                jobRoleDocs: jdFile,
              },
            }))
          } else {
            setTimeout(() => {
              clearInterval(interval)
              setParseLoading(false)
              setDeleteRole(false)
              setProgress(0)
              setSave(false)
              setJdFile([])
              setLoading(false)
              setRoleFormData(prev => ({
                ...prev,
                jdDetails: {
                  ...prev.jdDetails,
                  jobRoleDocs: [],
                },
              }))
              ErrorMessage('Failed to parse this JD !')
            }, 100)
          }
        } else {
          roleDeleted = true
          setTimeout(() => {
            clearInterval(interval)
            setParseLoading(false)
            setDeleteRole(false)
            setProgress(0)
            setSave(false)
            setJdFile([])
            setLoading(false)
            setRoleFormData(defaultRoleFormData)
            roleForm.setFieldsValue(defaultRoleFormData)
            ErrorMessage('Failed to parse this JD !')
          }, 100)
          return false
        }
      } else if (
        currentStep == autoJDFillStepNum &&
        (!jdFile?.length || params.roleId || (jdFile?.length && !deleteRole))
      ) {
        setTimeout(() => {
          localStorage.removeItem('jdDetails')
          localStorage.removeItem('jdFile')
          setParseLoading(false)
          setDeleteRole(false)
          setLoading(false)
          setCurrentStep(currentStep + 1)
        }, 2000)
      }

      let gigsStatus = false
      let jobLevelStatus = false
      gigsStatus = checkValidation(
        'jobCategory',
        'GIGS',
        'durationFirstYear',
        'durationFirstMonth',
        'durationSecondYear',
        'durationSecondMonth',
        setGigsErr,
        gigsStatus,
        'gigsError',
        'Please enter a duration',
        'Please enter a valid duration'
      )

      if (
        roleFormData?.jobDetails?.jobTypeLevels == 'BOTH' ||
        roleFormData?.jobDetails?.jobTypeLevels == 'EXPERIENCED'
      ) {
        jobLevelStatus = checkValidation(
          'jobTypeLevels',
          roleFormData?.jobDetails?.jobTypeLevels,
          'firstYear',
          'firstMonth',
          'secondYear',
          'secondMonth',
          setExperienceErr,
          jobLevelStatus,
          'jobLevel_status_Id',
          'Please enter the experience',
          'Please enter the valid experience'
        )
      }
      let skillError = false
      const validationCheckingOnRole = criteriaData?.length > 0
      const skillValidationCheck = roleFormData?.mandatorySkills?.primary?.type
      if (!draft) {
        if (
          validationCheckingOnRole &&
          currentStep != eligibilityCriteriaStepNum
        ) {
          setQualificationError('')
        } else if (
          !validationCheckingOnRole &&
          currentStep == eligibilityCriteriaStepNum
        ) {
          setQualificationError('Please Select Qualification')
          setSave(false)
          ScrollRef()
        }
        if (
          skillValidationCheck == '' &&
          currentStep == eligibilityCriteriaStepNum &&
          roleFormData?.mandatorySkills?.primary?.skills?.length > 0
        ) {
          setMandatoryTypeError(true)
          skillError = true
        } else {
          setMandatoryTypeError(false)
          skillError = false
        }
      }
      updateEditedFlags()
      await roleForm.validateFields()
      if (
        roleFormData?.status == 1 &&
        !roleFormData?.republishedDate &&
        currentStep == eligibilityCriteriaStepNum &&
        !stepStatus?.qualification
      ) {
        return
      }
      const jobDetails = roleFormData?.jobDetails
      const Others = 'OTHERS'
      const otherLinks = jobDetails?.otherLinks
        ?.filter(item => item.link.trim() !== '')
        .map(item => item.link?.trim())
      let payloadJobDetails = {
        tittle: jobDetails?.jobTitle,
        designationId: jobDetails?.designationId,
        function:
          jobDetails?.jobFunction === Others
            ? jobDetails?.otherJobFunction
            : jobDetails?.jobFunction,
        functionId: jobDetails?.functionId,
        jobTypeLevels: [roleFormData?.jobDetails?.jobTypeLevels],
        yearOfExperience:
          jobDetails?.firstYear ||
          jobDetails?.secondYear ||
          jobDetails?.secondMonth
            ? calculateYearsOfExperience(roleFormData?.jobDetails)
            : [0],
        jobType: roleFormData?.jobDetails?.jobType,
        employmentType: jobDetails?.employmentType,
        jobCategory: jobDetails?.jobCategory,
        jobDependency: '',
        description: roleFormData?.jobDetails?.description || '',
        minVacancies: 0,
        maxVacancies: 0,
        startDate: roleFormData?.jobDetails?.startDate
          ? dateConversion({
              date: roleFormData?.jobDetails?.startDate,
              convertTo: 'YYYY-MM-DD',
            }) + 'T00:00:00.000Z'
          : moment(
              dateConversion({
                date: new Date().toISOString()?.split('T')[0],
                convertTo: 'DD/MM/YYYY',
              }),
              dateFormat
            ).format('YYYY-MM-DD') + 'T00:00:00.000Z',
        endDate:
          roleFormData?.jobDetails?.endDate &&
          timeCheck(roleFormData?.jobDetails?.endTime)
            ? dateConversion({
                date: roleFormData?.jobDetails?.endDate,
                convertTo: 'YYYY-MM-DD',
              }) +
              'T' +
              timeCheck(roleFormData?.jobDetails?.endTime) +
              ':00.000Z'
            : roleFormData?.jobDetails?.endDate &&
              !timeCheck(roleFormData?.jobDetails?.endTime)
            ? dateConversion({
                date: roleFormData?.jobDetails?.endDate,
                convertTo: 'YYYY-MM-DD',
              }) +
              'T' +
              '00:00' +
              ':00.000Z'
            : null,
        publishTo: 'ALL',
        internshipStartDate: null,
        internshipEndDate: null,
        workStyle: (() => {
          const workStyleValue = roleFormData?.jobDetails?.workStyle;
          console.log('Sending workStyle to backend:', workStyleValue);
          return workStyleValue;
        })(),
        externalLink: jobDetails?.externalLink,
        jdDetails: jdFile?.length && jobDetailsForm ? jobDetailsForm : {},
        jdUrl: completedProcess ? jdFile || [] : [],
      }
      let selectedCompany

      if (
        isValidUUID(jobDetails?.companyId) &&
        isValidUUID(jobDetails?.companyName)
      ) {
        selectedCompany = companyList.filter(
          item => item.id === jobDetails?.companyId
        )[0].companyName
      }
      const mappedCities =
        (roleFormData?.jobLocation?.cities || []).map(item => item?.payload ?? item)

      let companyDetails = {
        companyName: isValidUUID(jobDetails?.companyName)
          ? selectedCompany ?? jobDetails?.companyName
          : jobDetails?.companyName == 'OTHERS'
          ? roleForm.getFieldValue(['jobDetails', 'otherCompanyName'])
          : jobDetails?.companyName,
        website: jobDetails?.companyWebsite,
        otherLinks: otherLinks || [],
        sector: jobDetails?.sector,
        sectorId: jobDetails?.sectorId,
        description: jobDetails?.companyDescription,
      }
      const republishedDate =
        roleFormData?.status === 1 && currentStep >= previewStepNum
          ? roleFormData?.republishedDate ||
            (isDateOnlyEdited && !roleFormData?.republishedDate)
            ? roleFormData?.republishedDate || null
            : new Date()
          : roleFormData?.republishedDate

      let payload = {
        ...(editData?.interviewWorkFlow?.length !== 0 &&
        editData?.interviewWorkFlow?.rounds?.length !== 0
          ? { interviewWorkFlow: editData?.interviewWorkFlow }
          : {}),
        jobDetails: { ...payloadJobDetails },
        companyDetails: { ...companyDetails },
        ctc: {
          isBond: roleFormData?.ctc?.isBond,
          bondType: roleFormData?.ctc?.isBond
            ? roleFormData?.ctc?.bondType
            : '',
          additionalBenefits: roleFormData?.ctc?.isAdditional
            ? roleFormData?.ctc?.additionalBenefits
            : '',
          stipend: roleFormData?.ctc?.isNoStipend,
          min: roleFormData?.ctc?.min && roleFormData?.ctc?.min !== '' ? Number(roleFormData?.ctc?.min) : 0,
          max: roleFormData?.ctc?.max && roleFormData?.ctc?.max !== '' ? Number(roleFormData?.ctc?.max) : null,
          variableAmount: roleFormData?.ctc?.ctcType === 'FIXED_VARIABLE' && roleFormData?.ctc?.variableAmount !== '' ? roleFormData?.ctc?.variableAmount : null,
          period: roleFormData?.ctc?.period || (roleFormData?.jobDetails?.jobCategory === 'PLACEMENT' ? 'ANNUALLY' : 'MONTHLY'),
        },
        jobLocation: {
          ...(roleFormData.jobLocation || {}),
          cities: mappedCities,
          citiesIds: roleFormData?.jobLocation?.citiesIds || [],
          isAnyWhere: roleFormData?.jobLocation?.isAnyWhere !== undefined ? roleFormData?.jobLocation?.isAnyWhere : true,
        },
        elgibilty: {
          roleFlotedTo: roleFormData?.roleFlotedTo,
          degreeStreamMapIds: roleFormData?.degrees?.degreesData,
          isArrearsAllowed: roleFormData?.isArrearsAllowed,
          isHistoryArrears: roleFormData?.isHistoryArrears,
          arrearCount: {
            condition: roleFormData?.arrearCount?.condition,
            count: roleFormData?.isArrearsAllowed
              ? roleFormData?.arrearCount?.count
              : 0,
          },

          historyArrearCount: {
            condition: roleFormData?.historyArrearCount?.condition,
            count: roleFormData?.isHistoryArrears
              ? roleFormData?.historyArrearCount?.count
              : 0,
          },
          eligibilityCriteria: criteriaData,
          JobRoleSkills: selectedSkills?.map(skill => ({
            ...skill,
            skillId: skill.skillId || skill.id || skill.value || skill.skillName
          })).filter(skill => skill.skillId) || [],
          yearOfPassing: roleFormData?.yearOfPassing,

          scores: {
            condition: 'LTE',

            tenth: Number(roleFormData?.scores?.tenth),
            twelfth: Number(roleFormData?.scores?.twelfth),
          },
        },
        status: roleFormData?.status,
        republishedDate: republishedDate,
        forRevert: values == 'revert' ? data : false,
      }

      if (jobDetails?.companyId) {
        payload.jobDetails.companyId = jobDetails?.companyId
      }
      if (roleFormData?.ctc?.ctcType) {
        payload.ctc.ctcType = roleFormData?.ctc?.ctcType
      }
      if (jobDetails?.jobRoleDocs) {
        console.log('=== PAYLOAD ATTACHMENT DEBUG ===');
        console.log('Original jobRoleDocs in payload:', jobDetails?.jobRoleDocs);
        
        let docsArr = jobDetails?.jobRoleDocs
          .filter(item => {
            // Filter out empty/invalid attachments
            const isValid = item.name && item.url && item.name.trim() !== '' && item.url.trim() !== ''
            console.log('Payload attachment validation:', { item, isValid });
            return isValid
          })
          .map(item => {
            return {
              fileName: item.name,
              fileType: item.type || '',
              fileUrl: item.url,
              fileSize: item.size || '',
            }
          })
        
        console.log('Final docsArr for payload:', docsArr);
        payload.jobDetails.jobRoleDocs = docsArr
      }
      payload.jobDetails.internshipDuration = jobDetails?.internshipDuration

      if (jobDetails?.jobCategory === 'GIGS') {
        payload.jobDetails.gigsDuration =
          jobDetails?.durationFirstYear || jobDetails?.durationSecondYear
            ? calculateGigsDuration(roleFormData?.jobDetails)
            : [0.0, 0.0]
      } else {
        payload.jobDetails.gigsDuration = [0]
      }

      if (jobDetails?.jobCategory) {
        if (payload.ctc) {
          payload.ctc.period = roleFormData?.ctc?.period
        }
      }
      // Debug: Log payload before API call
      console.log('Job Role Payload before API call:', JSON.stringify(payload, null, 2));
      
      if (selectedSpecialisations?.length > 0) {
        payload = {
          ...payload,
          elgibilty: {
            ...payload?.elgibilty,
            specialisations: removeDuplicatesFromArray(
              selectedSpecialisations,
              'specialisationsId'
            ),
          },
        }
      }

      if (roleFormData?.qualityCriteria[0]?.totalTypes?.length > 0) {
        roleFormData.qualityCriteria[0].totalTypes.forEach(item => {
          if (item === 'DIPLOMA') {
            payload.elgibilty.scores.UGDiploma = Number(
              roleFormData?.scores?.UGDiploma
            )
          } else if (item === 'UG') {
            payload.elgibilty.scores.UG = Number(roleFormData?.scores?.UG)
          } else if (item === 'PG') {
            payload.elgibilty.scores.PG = Number(roleFormData?.scores?.PG)
          }
        })
      }

      if (scoreType == 'Average') {
        payload.elgibilty.scores.avg = Number(roleFormData?.scores?.tenth)
      }

      if (gigsStatus) {
        return false
      }
      if (jobLevelStatus) {
        return false
      }

      let response = null
      if (id && !roleDeleted) {
        let checkRoleDate = false

        if (
          currentStep == jobDetailsStepNum &&
          !isEditModal?.open &&
          roleFormData?.republishedDate &&
          !isEditModal?.loading
        ) {
          checkRoleDate = await checkApplicationDate()
        } else if (
          roleFormData?.status == 1 &&
          currentStep != previewStepNum &&
          !isEditModal?.open
        ) {
          if (isEditModal?.loading) {
            setConfirmLoading(true)
          }
          if (fromTabChange) {
            setFromTabChange(false)
            if (stepToGo) {
              setCurrentStep(stepToGo)
            } else {
              setCurrentStep(currentStep + 1)
            }
          } else {
            setCurrentStep(currentStep + 1)
          }
          setSave(false)
          return
        }
        if (!checkRoleDate) {
          response = updateNewRole(
            payload,
            setLoad,
            id,
            validationCheckingOnRole,
            currentStep,
            skillError,
            scoreError,
            action,
            stepToGo
          )
        }
      } else {
        if (currentStep == autoJDFillStepNum && completedProcess) {
          window.history.replaceState(
            null,
            '',
            `/jobRoles/newRole?CS=${jobDetailsStepNum}`
          )
          setCurrentStep(jobDetailsStepNum)
          setSave(false)
        } else {
          response = await onAddNewRole({
            ...payload.jobDetails,
            companyDetails: { ...payload.companyDetails },
          })
        }
      }
      return response
    } catch (err) {
      setSave(false)
      if (err?.errorFields?.length > 0) {
        const element = document.getElementById(
          err?.errorFields[0]?.name?.join('_')
        )
        const helpElement = document.getElementById(
          err?.errorFields[0]?.name?.join('_') + '_help'
        )
        const firstErrorElement = document.getElementById('applicationEndError')
        const applicationEndDateError =
          'jobDetails_endDate' == err?.errorFields[0]?.name?.join('_')

        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        } else if (helpElement) {
          helpElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        } else if (applicationEndDateError) {
          firstErrorElement?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        } else {
          roleForm.scrollToField(err?.errorFields[0].name)
        }
      }
    } finally {
      //console.log('finally')
    }
  }

  const submitData = () => {
    onSubmitFormData()
  }

  useEffect(() => {
    if (save) {
      if (currentStep >= previewStepNum && publishCheck) {
        setShowRoleDrawer(true)
      } else {
        submitData()
      }
    }
  }, [save, publishCheck])
  const handleRemoveQualificationSelection = (
    index,
    field,
    isRemove,
    degreeId,
    departmentId,
    specialisationId,
    type
  ) => {
    let data = {
      index,
      field,
      isSelected: isRemove,
      id: degreeId,
      departmentId,
      specId: specialisationId,
      type,
    }
    updateIsSelected(data)
  }

  function removeDuplicates(arr) {
    const unique = arr
      .map(e => JSON.stringify(e)) // Convert each object to a JSON string
      .filter((value, index, self) => self.indexOf(value) === index) // Filter duplicates
      .map(e => JSON.parse(e)) // Convert back to objects

    return unique
  }

  function mergeDegreeData(existingData, newData) {
    let result = [...existingData]

    if (existingData?.length) {
      result = existingData.map(deg => {
        const findDeg = newData?.find(item => item.degreeId === deg.degreeId)

        if (findDeg) {
          if (findDeg.isSelected) {
            // Separate selected (true) and non-selected (false) streams
            const falseStream =
              findDeg?.streams?.filter(item => !item?.isSelected) || []
            const trueStream =
              findDeg?.streams?.filter(item => item?.isSelected) || []

            // Process streams
            const updatedStreams =
              deg?.streams?.map(existingStream => {
                const matchedStream = findDeg?.streams?.find(
                  ns => ns.streamId === existingStream.streamId
                )

                if (matchedStream) {
                  if (matchedStream.isSelected) {
                    // Separate selected and unselected specialisations
                    const falseSpecialisations =
                      matchedStream?.specialisations?.filter(
                        spec => !spec?.isSelected
                      ) || []
                    const trueSpecialisations =
                      matchedStream?.specialisations?.filter(
                        spec => spec?.isSelected
                      ) || []

                    // Remove specialisations that are false
                    const filteredSpecialisations =
                      existingStream?.specialisations?.filter(
                        spec =>
                          !falseSpecialisations.some(
                            fs => fs.specialisationId === spec.specialisationId
                          )
                      ) || []

                    // Add only new selected specialisations
                    const updatedSpecialisations = [
                      ...filteredSpecialisations,
                      ...trueSpecialisations.filter(
                        ts =>
                          !filteredSpecialisations.some(
                            fs => fs.specialisationId === ts.specialisationId
                          )
                      ),
                    ]

                    return {
                      ...existingStream,
                      specialisations: updatedSpecialisations,
                    }
                  } else {
                    return {
                      ...existingStream,
                      isSelected: false,
                      specialisations: [],
                    }
                  }
                }

                return existingStream
              }) || []

            // Remove streams that are false in newData
            const finalStreams = updatedStreams.filter(
              item => !falseStream.some(s => item?.streamId === s?.streamId)
            )

            // Add new selected streams only if not already present
            const fullUpdatedStreams = [
              ...finalStreams,
              ...trueStream.filter(
                ts => !finalStreams.some(fs => fs.streamId === ts.streamId)
              ),
            ]

            return { ...deg, streams: fullUpdatedStreams }
          } else {
            const falseStream =
              findDeg?.streams?.filter(item => !item?.isSelected) || []

            const filteredStreams = deg?.streams?.filter(
              item => !falseStream.some(r => r?.streamId === item?.streamId)
            )

            const selectedDegree = filteredStreams?.filter(
              item => item?.isSelected
            )

            return {
              ...deg,
              isSelected: false,
              streams: [],
            }
          }
        }

        return deg
      })
    }

    newData.forEach(newDeg => {
      const exists = existingData.some(deg => deg.degreeId === newDeg.degreeId)
      if (!exists) {
        result.push(newDeg)
      }
    })

    // Combine newData with filteredResult

    const combinedResult = result
      ?.map(deg => {
        if (deg?.streams?.length > 0) {
          const updatedStreams = deg.streams
            ?.map(str => {
              if (str?.specialisations?.length > 0) {
                const updatedSpecialisations = str.specialisations?.filter(
                  spec => spec?.isSelected
                )

                return { ...str, specialisations: updatedSpecialisations }
              }
              return str
            })
            ?.filter(str => str?.isSelected)

          return { ...deg, streams: updatedStreams }
        }
        return deg
      })
      ?.filter(deg => deg?.isSelected)

    const uniqueData = removeDuplicates(combinedResult)

    return uniqueData
  }

  const filterSelected = data => {
    // const filterSelectedDomain = data?.filter((domain)=>domain?.isSelected)
    // const filteredDegree = removeFalseData
    return (
      data
        // ?.filter(degree => degree.isSelected)
        ?.map(degree => ({
          degreeId: degree.degreeId,
          degreeShortForm: degree.degreeShortForm,
          isSelected: degree?.isSelected,
          type: degree?.type,
          streams: degree.streams
            // ?.filter(stream => stream.isSelected)
            ?.map(stream => ({
              streamId: stream.streamId,
              streamName: stream.streamName,
              isSelected: stream.isSelected,
              specialisations:
                stream.specialisations?.length > 0
                  ? stream.specialisations
                  : [],
            })),
        }))
    )
  }

  const updateIsSelected = vData => {
    const {
      index,
      field,
      isSelected,
      id,
      departmentId,
      specId,
      type = selectedType?.find(i => i?.key === index)?.value,
    } = vData
    setQualificationError('')
    if (field == 'degree' || field == 'stream' || field == 'specialisation') {
      const isDegreeSelected = id && !departmentId && !specId
      const isStreamSelected = id && departmentId && !specId
      const isSpecSelected = id && departmentId && specId
      const findDataQualityCriteriaArr =
        roleFormData?.qualityCriteria?.[index]?.data ||
        roleFormData?.qualityCriteria?.[index]?.selected[type]?.data

      const updatedDataQualityCriteriaArr = findDataQualityCriteriaArr?.map(
        item => {
          if (item.degreeId == id) {
            if (item.streams?.length > 0 && departmentId) {
              return {
                ...item,
                isSelected:
                  (specId || departmentId) && isSelected
                    ? true
                    : item.isSelected,
                streams: item.streams.map(stream => {
                  if (stream.streamId == departmentId) {
                    if (stream.specialisations?.length > 0 && specId) {
                      return {
                        ...stream,
                        isSelected:
                          specId && isSelected ? true : stream.isSelected,
                        specialisations: stream.specialisations.map(
                          specialisation => {
                            if (specialisation.specialisationId == specId) {
                              return {
                                ...specialisation,
                                isSelected: isSelected,
                              }
                            }
                            return specialisation
                          }
                        ),
                      }
                    }
                    const specialisations = stream?.specialisations?.map(
                      sp => ({
                        ...sp,
                        isSelected: isSelected ? sp.isSelected : false,
                      })
                    )
                    return {
                      ...stream,
                      isSelected: isSelected,
                      specialisations: specialisations,
                    }
                  }
                  return stream
                }),
              }
            }
            const streams = item.streams?.map(s => ({
              ...s,
              isSelected: isSelected ? s.isSelected : false,
              specialisations: s.specialisations?.map(sp => ({
                ...sp,
                isSelected: isSelected ? sp.isSelected : false,
              })),
            }))
            return {
              ...item,
              isSelected: isSelected,
              streams: streams,
            }
          }
          return item
        }
      )

      const selectedDegObj = updatedDataQualityCriteriaArr?.find(
        item => item.degreeId === id
      )
      const selectedDeptObj = selectedDegObj?.streams?.find(
        item => item.streamId === departmentId
      )
      const selectedSpecObj = selectedDeptObj?.specialisations?.find(
        item => item.specialisationId === specId
      )

      let data =
        roleFormData?.qualityCriteria?.[index]?.selected[type]?.data ?? []

      const degree = data?.find(deg => deg.degreeId === id)
      const stream = degree?.streams?.find(str => str.streamId === departmentId)
      const selectedObj = isDegreeSelected
        ? {
            ...selectedDegObj,
            streams: [],
          }
        : isStreamSelected
        ? {
            ...selectedDegObj,
            streams: [
              {
                ...selectedDeptObj,
                specialisations: [],
              },
            ],
          }
        : {
            ...selectedDegObj,
            streams: [
              {
                ...selectedDeptObj,
                specialisations: [selectedSpecObj],
              },
            ],
          }

      if (data?.length === 0) {
        data = [selectedObj]
      } else if (isSelected) {
        if (degree) {
          const isStrExist = degree?.streams?.some(
            item => item?.streamId === departmentId
          )
          if (isSpecSelected && isStrExist) {
            stream?.specialisations?.push(selectedSpecObj)
          } else if (isDegreeSelected) {
            degree.streams = []
          } else {
            let newObj = {
              ...selectedDeptObj,
              specialisations: isStreamSelected
                ? []
                : selectedDeptObj?.specialisations?.filter(
                    item => item.isSelected
                  ),
            }
            degree?.streams?.push(newObj)
          }
        } else {
          data?.push(selectedObj)
        }
      } else {
        if (degree) {
          const isStrExist = degree?.streams?.some(
            item => item?.streamId === departmentId
          )
          const isDegExist = data?.some(item => item?.degreeId === id)
          if (isSpecSelected && isStrExist) {
            stream.specialisations = stream?.specialisations?.filter(
              spec => spec?.specialisationId !== specId
            )
          } else if (isStreamSelected && isDegExist) {
            degree.streams = degree?.streams?.filter(
              str => str?.streamId !== departmentId
            )
          } else {
            data = data?.filter(deg => deg?.degreeId !== id)
          }
        }
      }
      setRoleFormData(prevData => {
        // Step 1: Update the `qualityCriteria` array
        const updatedCriteria = prevData.qualityCriteria.map((item, i) => {
          if (i === index) {
            const updatedType = Object.entries(item.selected || {})
              .filter(([key, details]) =>
                type === key
                  ? details?.isAllDegree || data?.length > 0
                  : details?.isAllDegree || details?.data?.length > 0
              )
              .map(([key]) => key)
            return {
              ...item,
              data: updatedDataQualityCriteriaArr,
              selected: {
                ...item.selected,
                [type]: {
                  ...item.selected[type],
                  data: data, // Update `data` for the selected `type`
                },
              },
              type: updatedType, // Set `type` for the current item
            }
          }
          return item
        })

        const updatedCriteriaWithTotalTypes = getEligibilityTypes(
          index,
          updatedCriteria
        )
        // Step 4: Return the updated state
        return {
          ...prevData,
          qualityCriteria: updatedCriteriaWithTotalTypes,
        }
      })
    } else if (field == 'allDegree') {
      const updatedData = roleFormData?.qualityCriteria?.[index]?.data?.map(
        domain => {
          const streamMapping =
            Array?.isArray(domain?.streams) &&
            domain?.streams?.map(stream => {
              const specializationMapping =
                Array?.isArray(stream?.specialisations) &&
                stream?.specialisations?.map(spec => {
                  return {
                    ...spec,
                    isSelected: false,
                  }
                })
              return {
                ...stream,
                isSelected: false,
                specialisations: specializationMapping,
              }
            })
          return {
            ...domain,
            isSelected: isSelected,
            streams: streamMapping,
          }
        }
      )
      setSelectedData(updatedData)
      setRoleFormData(prevData => {
        const newQualityCriteria = prevData.qualityCriteria.map((item, i) => {
          let selectedDegreeData = filterSelected(updatedData)
          let mergeData
          if (!isSelected) {
            let filterIds = updatedData?.map(item => item.degreeId)
            mergeData = item?.selected?.[
              selectedType?.find(i => i?.key === index)?.value
            ]?.data?.filter(item => !filterIds?.includes(item.degreeId))
          } else {
            mergeData = mergeDegreeData(
              item?.selected?.[selectedType?.find(i => i?.key === index)?.value]
                ?.data ?? [],
              selectedDegreeData
            )
          }

          if (i === index) {
            return {
              ...item,
              data: updatedData,
              selected: {
                ...item.selected,
                [selectedType?.find(i => i?.key === index)?.value]: {
                  ...item.selected?.[
                    selectedType?.find(i => i?.key === index)?.value
                  ],
                  data: mergeData,
                },
              },
            }
          }
          return item
        })
        const updatedQualityCriteriaArrayWithTypes = getEligibilityTypes(
          index,
          newQualityCriteria
        )
        return {
          ...prevData,
          qualityCriteria: updatedQualityCriteriaArrayWithTypes,
        }
      })
    } else if (field == 'allStream') {
      const updatedData = roleFormData?.qualityCriteria?.[index]?.data?.map(
        domain => {
          if (domain?.streams?.length > 0) {
            domain?.streams?.forEach(stream => {
              stream.isSelected = isSelected
              stream?.specialisations?.forEach(speciaisation => {
                speciaisation.isSelected = isSelected
                  ? speciaisation?.isSelected
                  : isSelected
              })
            })
          }
          return {
            ...domain,
            isSelected: isSelected ? true : domain.isSelected,
            isExpanded: isSelected,
          }
        }
      )

      setRoleFormData(prevData => {
        const newQualityCriteria = prevData.qualityCriteria.map((item, i) => {
          let selectedDegreeData = filterSelected(updatedData)
          const mergeData = mergeDegreeData(
            item?.selected?.[selectedType?.find(i => i?.key === index)?.value]
              ?.data ?? [],
            selectedDegreeData
          )
          if (i === index) {
            return {
              ...item,
              data: updatedData,
              selected: {
                ...item.selected,
                [selectedType?.find(i => i?.key === index)?.value]: {
                  ...item.selected?.[
                    selectedType?.find(i => i?.key === index)?.value
                  ],
                  data: mergeData,
                },
              },
            }
          }
          return item
        })

        const updatedQualityCriteriaArrayWithTypes = getEligibilityTypes(
          index,
          newQualityCriteria
        )
        return {
          ...prevData,
          qualityCriteria: updatedQualityCriteriaArrayWithTypes,
        }
      })
      setSelectedData(updatedData)
    } else {
      const updatedData = roleFormData?.qualityCriteria?.[index]?.data.map(
        degree => {
          let degreeSelected = degree?.isSelected
          const updatedStreams = degree.streams.map(stream => {
            let streamSelected = stream?.isSelected
            const updatedSpecialisations = stream.specialisations.map(
              specialisation => {
                if (specialisation) {
                  streamSelected = true
                  degreeSelected = true
                }
                return { ...specialisation, isSelected: isSelected }
              }
            )
            return {
              ...stream,
              specialisations: updatedSpecialisations,
              isSelected: streamSelected,
              isExpanded: isSelected,
            }
          })
          return {
            ...degree,
            streams: updatedStreams,
            isSelected: degreeSelected,
            isExpanded: true,
          }
        }
      )

      setRoleFormData(prevData => {
        const newQualityCriteria = prevData.qualityCriteria.map((item, i) => {
          let selectedDegreeData = filterSelected(updatedData)

          const mergeData = mergeDegreeData(
            item?.selected?.[selectedType?.find(i => i?.key === index)?.value]
              ?.data ?? [],
            selectedDegreeData
          )

          if (i === index) {
            return {
              ...item,
              data: updatedData,
              selected: {
                ...item.selected,
                [selectedType?.find(i => i?.key === index)?.value]: {
                  ...item.selected?.[
                    selectedType?.find(i => i?.key === index)?.value
                  ],
                  data: mergeData,
                },
              },
            }
          }
          return item
        })
        const updatedQualityCriteriaArrayWithTypes = getEligibilityTypes(
          index,
          newQualityCriteria
        )
        return {
          ...prevData,
          qualityCriteria: updatedQualityCriteriaArrayWithTypes,
        }
      })
      setSelectedData(updatedData)
    }
  }

  const setArrowExpand = vData => {
    const {
      index,
      field,
      id,
      departmentId,
      specId,
      type = selectedType?.find(i => i?.key === index)?.value,
      isExpanded,
    } = vData
    setQualificationError('')
    if (field == 'degree' || field == 'stream' || field == 'specialisation') {
      const findDataQualityCriteriaArr =
        roleFormData?.qualityCriteria?.[index]?.data ||
        roleFormData?.qualityCriteria?.[index]?.selected[type]?.data

      const updatedDataQualityCriteriaArr = findDataQualityCriteriaArr?.map(
        item => {
          if (item.degreeId == id) {
            if (item.streams?.length > 0 && departmentId) {
              return {
                ...item,
                isExpanded: item?.isExpanded,
                streams: item.streams.map(stream => {
                  if (stream.streamId == departmentId) {
                    if (stream.specialisations?.length > 0 && specId) {
                      return {
                        ...stream,
                        isExpanded: isExpanded,
                        specialisations: stream.specialisations.map(
                          specialisation => {
                            if (specialisation.specialisationId == specId) {
                              return {
                                ...specialisation,
                              }
                            }
                            return specialisation
                          }
                        ),
                      }
                    }
                    return {
                      ...stream,
                      isExpanded: isExpanded,
                    }
                  }
                  return stream
                }),
              }
            }
            const streams = item.streams?.map(s => ({
              ...s,
              isExpanded: isExpanded ? s?.isExpanded : false,
              specialisations: s.specialisations?.map(sp => ({
                ...sp,
              })),
            }))
            return {
              ...item,
              isExpanded: isExpanded,
              streams,
            }
          }
          return item
        }
      )

      setRoleFormData(prevData => {
        // Step 1: Update the `qualityCriteria` array
        const updatedCriteria = prevData.qualityCriteria.map((item, i) => {
          if (i === index) {
            return {
              ...item,
              data: updatedDataQualityCriteriaArr,
            }
          }
          return item
        })

        const updatedCriteriaWithTotalTypes = getEligibilityTypes(
          index,
          updatedCriteria
        )
        // Step 4: Return the updated state
        return {
          ...prevData,
          qualityCriteria: updatedCriteriaWithTotalTypes,
        }
      })
    }
  }

  const handleAllRemove = (data, index, field) => {
    setRoleFormData(prevData => {
      const newQualityCriteria = prevData.qualityCriteria.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            selected: {
              ...item.selected,
              [field]: {
                data: [],
                isAllDegree: false,
              },
            },
          }
        }
        return item
      })
      const updatedQualityCriteriaArrayWithTypes = getEligibilityTypes(
        index,
        newQualityCriteria
      )
      return {
        ...prevData,
        qualityCriteria: updatedQualityCriteriaArrayWithTypes,
      }
    })
  }
  useEffect(() => {
    if (roleFormData?.qualityCriteria?.length > 0) {
      let data = roleFormData?.qualityCriteria?.map(item => item.selected) || []
      const payloadData = payloadDataFormatForQualification(data)
      if (roleFormData?.status == 1 && !previewData?.republishedDate) {
        previewData.eligibilityCriteria = payloadDataFormatForPreviewData(
          roleFormData?.qualityCriteria,
          previewData
        )
      }
      setCriteriaData(payloadData)
    }
  }, [roleFormData?.qualityCriteria])

  useEffect(() => {
    const data = tabValidationChecking()
    console.log('Step validation results:', data)
    console.log('lengthOfTrueData will be:', Object.values(data).filter(value => value === true).length)
    console.log('Current roleFormData for validation:', {
      jobDetails: roleFormData?.jobDetails,
      ctc: roleFormData?.ctc,
      jobLocation: roleFormData?.jobLocation,
      qualityCriteria: roleFormData?.qualityCriteria
    })
    setStepStatus(data)
  }, [roleFormData])

  const checkApplicationDate = async stepIndex => {
    const endDateChangedValue = dateConversion({
      date: roleFormData?.jobDetails?.endDate,
      convertTo: 'YYYY-MM-DD',
    })

    const endDateValue = dateConversion({
      date: initialResponse?.endDate,
      convertTo: 'YYYY-MM-DD',
    })
    const startDateChangedValue = dateConversion({
      date: roleFormData?.jobDetails?.startDate,
      convertTo: 'YYYY-MM-DD',
    })

    const startDateValue = dateConversion({
      date: initialResponse?.startDate,
      convertTo: 'YYYY-MM-DD',
    })

    const endTimeChangedValue = timeCheck(roleFormData?.jobDetails?.endTime)
    const endTimeValue = timeSplit(initialResponse?.endDate)

    if (
      (endDateChangedValue != endDateValue ||
        startDateChangedValue != startDateValue ||
        endTimeChangedValue != endTimeValue) &&
      (!roleFormData?.republishedDate ||
        (roleFormData?.status == 1 && roleFormData?.republishedDate)) &&
      (stepIndex <= previewStepNum || !stepIndex)
    ) {
      setIsEditModal(prevState => ({
        ...prevState,
        open: true,
      }))
      return true
    } else {
      if (stepIndex >= 0) {
        setCurrentStep(stepIndex)
      } else {
        return false
      }
    }
  }

  const onTabChange = async stepIndex => {
    setSave(false)
    setDraft(false)
    setPublishCheck(false)
    setFromTabChange(true)
    try {
      let skillError = false
      if (
        stepIndex >= currentStep &&
        ((hasNotChanged && id) ||
          (id && checkAllCompleted && !editData?.isEdit && !hasNotChanged))
      ) {
        if (
          isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate
          )
        ) {
          await roleForm.validateFields()
          checkApplicationDate(stepIndex)
        } else {
          await onSubmitFormData('', '', 'tab', stepIndex)
        }
      } else if (stepIndex < currentStep) {
        // await roleForm.validateFields()
        if ((stepIndex == autoJDFillStepNum || currentStep == previewStepNum) && id) {
          fetchRoleData({ roleId: id, mode: '', currentIndex: stepIndex })
        }
        await setCurrentStep(stepIndex)
      } else {
        const validationCheckingOnRole = criteriaData?.length > 0
        const skillValidationCheck =
          roleFormData?.mandatorySkills?.primary?.type

        if (!draft) {
          if (
            validationCheckingOnRole &&
            currentStep != eligibilityCriteriaStepNum
          ) {
            setQualificationError('')
          } else if (
            !validationCheckingOnRole &&
            currentStep == eligibilityCriteriaStepNum
          ) {
            setQualificationError('Please Select Qualification')
            ScrollRef()
            setSave(false)
          }
          if (
            skillValidationCheck == '' &&
            currentStep == eligibilityCriteriaStepNum
          ) {
            setMandatoryTypeError(true)
            skillError = true
          } else {
            setMandatoryTypeError(false)
            skillError = false
          }
        }
        await roleForm.validateFields()
        if (currentStep == autoJDFillStepNum) {
          setParseLoading(true)
        }
        const res = await onSubmitFormData('', '', 'tab', stepIndex)
        if (res?.message == 'Success') {
          if (stepIndex == 3) {
            let failedStep = stepIndex
            const { job, ctc, qualification } = stepStatus
            if (!job) {
              failedStep = 0
            } else if (!ctc) {
              failedStep = 1
            } else if (!qualification) {
              failedStep = 2
            }
            if (failedStep < stepIndex) {
              stepIndex = failedStep
            }
          }
          setCurrentStep(stepIndex)
          ScrollRef()
        }
      }
    } catch (err) {
      if (err?.errorFields?.length > 0) {
        const element = document.getElementById(
          err?.errorFields[0]?.name?.join('_')
        )
        const helpElement = document.getElementById(
          err?.errorFields[0]?.name?.join('_') + '_help'
        )
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        } else if (helpElement) {
          helpElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        } else {
          roleForm.scrollToField(err?.errorFields[0].name)
        }
      }
    }

    const editId = id

    if (stepIndex >= previewStepNum && id && roleFormData?.status != 1) {
      const res = await getJobRolePreview(editId)
      const apiPreviewData = res.data.data
      
      
      if (roleFormData?.ctc?.isNoStipend === false) {
        apiPreviewData.minCompensation = 0
        apiPreviewData.maxCompensation = 0
        apiPreviewData.stipend = false
      }
      
      if (previewData?.endDate) {
        apiPreviewData.endDate = previewData.endDate
      }
      
      setPreviewData(apiPreviewData)
    }
  }
  const onFinishFailed = errorInfo => {
    if (errorInfo.errorFields.length > 0) {
      const firstError = errorInfo.errorFields[0].name[0]
      const element = document.getElementById(firstError)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }

  const handleEditClose = () => {
    setIsEditModal({
      loading: false,
      open: false,
    })
    setSave(false)
  }
  const handleEditConfirm = () => {
    setIsEditModal(prev => ({
      ...prev,
      loading: true,
    }))
    submitData()
  }

  const getEligibilityTypes = (index, newQualityCriteria) => {
    const finalDataWithType = newQualityCriteria.map((item, i) => {
      if (i === index) {
        return {
          ...item,

          type: Object.keys(item.selected).filter(
            key =>
              item.selected[key]?.data?.length > 0 ||
              item.selected[key]?.isAllDegree
          ),
        }
      }
      return item
    })
    const totalTypes = finalDataWithType
      ?.map(item => item.type)
      ?.flat()
      ?.filter(item => item !== '')
    const updatedQualityCriteriaArrayWithTypes = finalDataWithType.map(
      (item, i) => {
        if (i === index) {
          return {
            ...item,
            type: Object.keys(item.selected).filter(
              key =>
                item.selected[key]?.data?.length > 0 ||
                item.selected[key]?.isAllDegree
            ),
            totalTypes: totalTypes,
          }
        } else {
          return { ...item, totalTypes: totalTypes }
        }
      }
    )
    return updatedQualityCriteriaArrayWithTypes
  }

  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName ?? 'Admin'
  }

  const getUserRoleName = () => {
    return getRoleName(
      userData?.pluginlive_id
        ? userData?.admin?.instRoleId
        : userData?.admin_role_id ?? userData?.role_id
    )
  }

  const onFinish = async values => {
    try {
      // Clean up CTC data before submission
      const cleanedValues = { ...values };
      
      if (cleanedValues.ctc) {
        // If isRange is false or undefined, remove max value completely
        if (!cleanedValues.ctc.isRange) {
          delete cleanedValues.ctc.max;
        }
        
        // Remove null/undefined values that cause API issues
        Object.keys(cleanedValues.ctc).forEach(key => {
          if (cleanedValues.ctc[key] === null || cleanedValues.ctc[key] === undefined) {
            delete cleanedValues.ctc[key];
          }
        });
        
        // Ensure min is a number if it exists
        if (cleanedValues.ctc.min !== undefined && cleanedValues.ctc.min !== '') {
          cleanedValues.ctc.min = Number(cleanedValues.ctc.min);
        }
        
        // Ensure max is a number if it exists and range is enabled
        if (cleanedValues.ctc.max !== undefined && cleanedValues.ctc.max !== '' && cleanedValues.ctc.isRange) {
          cleanedValues.ctc.max = Number(cleanedValues.ctc.max);
        }
      }

      // Continue with existing submission logic using cleanedValues
      console.log('Cleaned CTC payload:', cleanedValues.ctc);
      
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <Container>
      <LeftDiv>
        <StickyLeftDiv>
          <AntdSteps
            id={id}
            step={step}
            stepStatus={stepStatus}
            steps={stepData}
            current={currentStep}
            onTabChange={onTabChange}
            progressCheck={stepIcon}
            onChange={onTabChange}
            checkAllCompleted={checkAllCompleted}
            confirmLoading={confirmLoading}
          />
        </StickyLeftDiv>
      </LeftDiv>

      {!confirmLoading ? (
        <RightDiv ref={object}>
          <Form
            scrollToFirstError
            onFinish={onFinish}
            style={{ marginBottom: '100px' }}
            id={'rolesForm'}
            form={roleForm}
            layout="vertical"
            initialValue={roleFormData}
            onFinishFailed={onFinishFailed}
          >
            {currentStep == autoJDFillStepNum && (
              <AutoJDFill
                setRoleFormData={setRoleFormData}
                roleFormData={roleFormData}
                setJdFile={setJdFile}
                jdFile={jdFile}
                getJdDetails={getJdDetails}
                parseLoading={parseLoading}
                setParseLoading={setParseLoading}
                progress={progress}
                params={params}
                setDeleteRole={setDeleteRole}
                deleteRole={deleteRole}
                handleNextChange={handleNextChange}
                setJdData={setJdData}
                setProgress={setProgress}
              />
            )}
            {currentStep == jobDetailsStepNum && (
              <>
                <JobDetails
                  lengthError={lengthError}
                  setLengthError={setLengthError}
                  setQualificationError={setQualificationError}
                  Form={Form}
                  key={key}
                  id={id}
                  dateFormat={dateFormat}
                  roleForm={roleForm}
                  setSave={setSave}
                  handleAddNewCompany={handleAddNewCompany}
                  labelName={labelName}
                  setLabelName={setLabelName}
                  setCompanyNameSearch={setCompanyNameSearch}
                  companyNameSearch={companyNameSearch}
                  setRoleNameSearch={setRoleNameSearch}
                  roleNameSearch={roleNameSearch}
                  setFunctionNameSearch={setFunctionNameSearch}
                  functionNameSearch={functionNameSearch}
                  setFunctionData={setFunctionData}
                  functionData={functionData}
                  functionApi={functionApi}
                  getMasterSearchApi={getMasterSearchApi}
                  roleFormData={roleFormData}
                  setRoleFormData={setRoleFormData}
                  roleApi={roleApi}
                  rolesList={rolesList}
                  companyList={companyList}
                  companiesApi={companiesApi}
                  setSelectedType={setSelectedTypeJobRoles}
                  selectedType={selectedTypeJobRoles}
                  setKey={setKey}
                  eligibleCandidatesMetrics={eligibleCandidatesMetrics}
                  gigsErr={gigsErr}
                  setGigsErr={setGigsErr}
                  experienceErr={experienceErr}
                  setExperienceErr={setExperienceErr}
                  draft={draft}
                  errorStatus={errorStatus}
                  jobDetailsForm={jobDetailsForm}
                  setInitialLoading={setInitialLoading}
                  params={params}
                  jdFile={jdFile}
                  getRolesListData={getRolesListData}
                  stepStatus={stepStatus}
                  triggerBack={triggerBack}
                  setPreviewData={setPreviewData}
                  previewData={previewData}
                />
              </>
            )}
            {currentStep == ctcOrStipendStepNum && (
              <StipendDetails
                current={currentStep}
                setQualificationError={setQualificationError}
                id={id}
                key={key}
                selectedType={selectedType}
                roleForm={roleForm}
                roleFormData={roleFormData}
                getListOfCities={getListOfCities}
                setSave={setSave}
                eligibleCandidatesMetrics={eligibleCandidatesMetrics}
                draft={draft}
                setRoleFormData={setRoleFormData}
                jobStipendForm={jobDetailsForm}
                params={params}
                searchCities={searchCities}
                stepStatus={stepStatus}
                triggerBack={triggerBack}
                setPreviewData={setPreviewData}
                previewData={previewData}
                getLocations={getCities}
              />
            )}
            {currentStep == eligibilityCriteriaStepNum && (
              <EligibiltyCriteria
                mandatorySkillsIds={mandatorySkillsIds}
                setMandatorySkillsIds={setMandatorySkillsIds}
                selectedSkills={selectedSkills}
                setSelectedSkills={setSelectedSkills}
                skillsManuallyModified={skillsManuallyModified}
                setSkillsManuallyModified={setSkillsManuallyModified}
                confirmLoading={confirmLoading}
                mandatoryTypeError={mandatoryTypeError}
                setMandatoryTypeError={setMandatoryTypeError}
                qualificationError={qualificationError}
                setQualificationError={setQualificationError}
                selectedData={selectedData}
                setSelectedData={setSelectedData}
                updateIsSelected={updateIsSelected}
                setSelectedType={setSelectedType}
                selectedType={selectedType}
                key={key}
                id={id}
                setSave={setSave}
                save={save}
                Form={Form}
                getDegreeData={getDegreeData}
                degreeList={degreeList}
                editData={editData}
                roleFormData={roleFormData}
                setRoleFormData={setRoleFormData}
                scoreError={scoreError}
                setScoreError={setScoreError}
                marksValue={marksValue}
                setMarksValue={setMarksValue}
                scoreType={scoreType}
                setScoreType={setScoreType}
                setSkillSearch={setSkillSearch}
                getMasterSearchApi={getMasterSearchApi}
                degreeListData={degreeListData}
                listOfMandatorySkills={listOfMandatorySkills}
                listOfOptionalSkills={listOfOptionalSkills}
                setListOfMandatorySkills={setListOfMandatorySkills}
                listOfSkills={listOfSkills}
                setListOfSkills={setListOfSkills}
                getSpecialisationList={getSpecialisationList}
                specialisationList={specialisationList}
                selectedSpecialisations={selectedSpecialisations}
                setSelectedSpecialisations={setSelectedSpecialisations}
                roleForm={roleForm}
                skillsCount={skillCount}
                criteriaCall={getEligibilityCriteriaQualification}
                eligibleCandidatesMetrics={eligibleCandidatesMetrics}
                checkAllCompleted={checkAllCompleted}
                draft={draft}
                jobEligibilityForm={jobDetailsForm}
                stepStatus={stepStatus}
                triggerBack={triggerBack}
                criteriaBasedCurrentCourse={getEligibilityCriteria}
                criteriaTypes={criteriaTypes}
                currentStep={currentStep}
                skillSearch={skillSearch}
                setArrowExpand={setArrowExpand}
                setPreviewData={setPreviewData}
                previewData={previewData}
                isEditRoleOnView={false}
              />
            )}
            {currentStep >= previewStepNum &&
              (previewData || jobRolePreviewData) && (
                <PreviewPage previewData={previewData || jobRolePreviewData} />
              )}
          </Form>
        </RightDiv>
      ) : (
        <Spin
          tip="Loading"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '50vh',
            width: '100vh',
          }}
        />
      )}
      <LastDiv>
        <StickyRightDiv>
          {currentStep != previewStepNum ? (
            <CompanyCard
              elgibileCount={candidateMetrics?.EligibleCandidatesCount || 0}
            />
          ) : (
            <PreviewScreenCard
              elgibileCount={candidateMetrics?.EligibleCandidatesCount || 0}
            />
          )}
        </StickyRightDiv>
        {currentStep == eligibilityCriteriaStepNum && (
          <StickyQualificationRightDiv>
            <QualificationSelectionBubble
              data={roleFormData?.qualityCriteria ?? []}
              handleRemoveFilter={handleRemoveQualificationSelection}
              handleAllRemove={handleAllRemove}
              checkAllCompleted={checkAllCompleted}
              isShow={roleFormData?.qualityCriteria?.some(
                item => item.totalTypes?.length > 0
              )}
              disabled={roleFormData?.republishedDate}
            />
          </StickyQualificationRightDiv>
        )}
      </LastDiv>
      <CloseRoleDrawer
        description={closeDrawerDescription}
        Icon={ShortlistIcon}
        showDrawer={showRoleDrawer}
        setShowDrawer={setShowRoleDrawer}
        onApprove={handleConfirmPublish}
        onCloseClick={() => {
          setShowRoleDrawer(false)
        }}
        loading={loading}
        setButtonLoading={setButtonLoading}
      />
      <CloseRoleDrawer
        description={
          <>
            Before publishing, would you like to remove ineligible students
            those who have already applied?
          </>
        }
        Icon={ShortlistIcon}
        showDrawer={revertStudentDrawer}
        setShowDrawer={setRevertStudentDrawer}
        onApprove={() => {
          handleRevertPop(true)
        }}
        onCloseClick={() => {
          handleRevertPop(false)
        }}
        loading={loading}
        setButtonLoading={setButtonLoading}
      />
      <NotificationModal
        isEditModal={isEditModal.open}
        handleEditConfirm={handleEditConfirm}
        isConfirmLoading={isEditModal.loading}
        handleEditClose={handleEditClose}
      />
    </Container>
  )
}

export default RolesForm
